<template>
  <div class="flex min-h-screen items-center justify-center bg-white p-5 text-center transition-colors dark:bg-gray-900" :class="{ dark: isDarkMode }">
    <div class="w-full max-w-md">
      <svg xmlns="http://www.w3.org/2000/svg" width="94" height="94" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto mb-5 text-red-500 dark:text-red-400" aria-hidden="true">
        <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z" />
        <circle cx="12" cy="12" r="10" />
      </svg>

      <p class="mb-2 text-5xl font-bold text-red-500 dark:text-red-400 md:text-6xl">404</p>
      <h1 class="mb-2 text-xl font-semibold text-gray-800 dark:text-gray-100 md:text-2xl">Página Não Encontrada</h1>
      <p class="mb-5 text-sm text-gray-600 dark:text-gray-300 md:text-base">Parece que você se perdeu na navegação.</p>

      <div class="flex justify-center">
        <a @click="handleLogout" class="inline-flex cursor-pointer items-center text-sm font-bold text-blue-600 transition hover:scale-105 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-200 md:text-base">
          Voltar ao Início
          <span class="ml-1 text-lg" aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { useRouter } from 'vue-router';
  
  export default {
    name: 'NotFound',
    data() {
      return {
        isDarkMode: true, // Altere dinamicamente com base no tema do sistema, se necessário
      };
    },
    setup() {
      const router = useRouter();
  
      const handleLogout = () => {
        sessionStorage.removeItem('api_token');
        sessionStorage.removeItem('token_expiry');
        sessionStorage.removeItem('username');
        sessionStorage.removeItem('firstname');
        sessionStorage.removeItem('lastname');
        sessionStorage.removeItem('user_groups');
        router.push({ name: 'Login' });
      };
  
      return { handleLogout };
    },
  };
  </script>
  
  
